/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is there no HD thumbnail for some videos?`)
};

const es_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué algunos videos no tienen miniatura HD?`)
};

const de_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum gibt es bei manchen Videos kein HD-Thumbnail?`)
};

const nl_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is er voor sommige video's geen HD-thumbnail?`)
};

const fr_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi certaines vidéos n’ont-elles pas de miniature HD ?`)
};

const it_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché alcuni video non hanno una miniatura HD?`)
};

const pt_br2_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que alguns vídeos não têm thumbnail em HD?`)
};

const pt_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque não há miniatura HD para alguns vídeos?`)
};

const ja_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部の動画にHDサムネイルがないのはなぜ？`)
};

const zh_yt_hd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么有些视频没有 HD 缩略图？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_faq2_q", locale)
	if (locale === "en") return en_yt_hd_faq2_q(inputs)
	if (locale === "es") return es_yt_hd_faq2_q(inputs)
	if (locale === "de") return de_yt_hd_faq2_q(inputs)
	if (locale === "nl") return nl_yt_hd_faq2_q(inputs)
	if (locale === "fr") return fr_yt_hd_faq2_q(inputs)
	if (locale === "it") return it_yt_hd_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_faq2_q(inputs)
	if (locale === "pt") return pt_yt_hd_faq2_q(inputs)
	if (locale === "ja") return ja_yt_hd_faq2_q(inputs)
	return zh_yt_hd_faq2_q(inputs)
};